import {useContext, useMemo} from "react";

import {LockService} from "../../../services";
import {HTTPContext} from "../../contexts";

export const useLockService = () => {
    const http = useContext(HTTPContext);
    return useMemo(() => new LockService(http), [http]);
};
